import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-navy-900" data-id="element-121">
      <div className="max-w-4xl mx-auto" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-navy-800 to-navy-900 p-8 md:p-12 rounded-2xl border border-gold-500/30 text-center relative overflow-hidden" data-id="element-123">
          {/* Background watermark */}
          <ShieldCheck className="absolute -right-10 -bottom-10 w-64 h-64 text-gold-500/5 rotate-12 pointer-events-none" data-id="element-124" />

          <div className="relative z-10" data-id="element-125">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gold-500/10 mb-6" data-id="element-126">
              <ShieldCheck className="w-10 h-10 text-gold-500" data-id="element-127" />
            </div>

            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-128">
              Garantía de "Nombre Limpio" de 7 Días
            </h2>

            <p className="text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-129">
              Si descargas el material, aplicas las plantillas y en 7 días no
              sientes que tienes el control total de tu situación financiera, te
              devuelvo cada peso. Sin preguntas, sin letras chicas.
              <br data-id="element-130" />
              <br data-id="element-131" />
              <strong className="text-gold-400" data-id="element-132">
                Me quedo con el riesgo yo, tú quédate con el conocimiento.
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}